import styled from "@emotion/styled";
import InnoIcons from "@InnoIcons/";
import theme from "@theme";

const BodyHeader = styled.div`
  padding: 16px 24px;
  background: ${theme.gradient.modernGlass};
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(227, 110, 0, 0.1);
  position: fixed;
  width: 100%;
  z-index: 1000;
  box-shadow: ${theme.modernTokens.shadows.sm};
`;

const BodyContainer = styled.div`
  margin-top: 60px;
`;

const FilterContainer = styled.div`
  border-bottom: 1px solid rgba(227, 110, 0, 0.1);
  padding: 16px 24px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
`;

const LeasingLayout = styled.div`
  border-bottom: 1px solid ${theme.colors.bordertask};
`;

const InputContiner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 500px;
`;

const SearchIcon = styled(InnoIcons.SearchIcon)`
  position: absolute;
  left: 10px;
  color: #888;
  font-size: 20px;
`;

const InputStyle = styled.input`
  width: 100%;
  padding: 8px 8px 8px 35px;
  font-size: 13px;
  border: 1px solid ${theme.colors.themeColor};
  border-radius: 5px;
  &:focus {
    outline: none;
    border-color: #ccc;
  }
`;

const SC = {
  BodyHeader,
  BodyContainer,
  FilterContainer,
  LeasingLayout,
  InputContiner,
  SearchIcon,
  InputStyle,
};

export default SC;
